import styled from 'styled-components';
import { TitleWithBenefitsStyled } from '../TitleWithBenefitsStyled';
import { rem } from 'polished';

export const TitleWithBenefitsStyledAP = styled(TitleWithBenefitsStyled)`
    .title {
        font-size: ${rem(25)};
        font-family: ${({ theme }) => theme.fonts.fontV2};
    }
    .specs {
        .specs-title > strong {
            font-family: ${({ theme }) => theme.fonts.fontV2};
        }
    }
    .benefits {
        .heading {
            font-family: ${({ theme }) => theme.fonts.fontV2};
        }
        .bullet-points.allow-bullet-points {
            padding-left: ${rem('16px')};
            .offer > div:first-child {
                max-width: 98%;
            }
            .offer svg {
                circle {
                    fill: none;
                    stroke: ${({ theme }) => theme.colors.primary};
                }

                line {
                    stroke: ${({ theme }) => theme.colors.primary};
                    stroke-width: ${rem('3px')};
                }
            }
        }
    }
`;
